import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["accessCodeType"]

  onChangeKeypadStyle(event) {
    const value = event.target.value;
    const options = this.accessCodeTypeTarget.querySelectorAll("option")

    if (value !== "passcode") {
      options.forEach(option => {
        const n = parseInt(option.value)
        if (n > 5) {
          option.disabled = true
        }
      })
      const currentlySelected = this.accessCodeTypeTarget.querySelector("option:checked")
      if (currentlySelected.value != "" && parseInt(currentlySelected.value) > 5) {
        this.accessCodeTypeTarget.value = ""
      }
    } else {
      options.forEach(option => { option.disabled = false })
    }
  }
}
